import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const marginConfig = {
  margin: {
    property: 'margin'
  },
  marginTop: {
    property: 'marginTop'
  },
  marginRight: {
    property: 'marginRight'
  },
  marginBottom: {
    property: 'marginBottom'
  },
  marginLeft: {
    property: 'marginLeft'
  },
  marginBlockStart: {
    property: 'marginBlockStart'
  },
  marginBlockEnd: {
    property: 'marginBlockEnd'
  },
  marginInlineStart: {
    property: 'marginInlineStart'
  },
  marginInlineEnd: {
    property: 'marginInlineEnd'
  },
  marginBlock: {
    property: 'marginBlock'
  },
  marginInline: {
    property: 'marginInline'
  }
};
const marginShorthandConfig = {};
marginShorthandConfig.m = marginConfig.margin;
marginShorthandConfig.mt = marginConfig.marginTop;
marginShorthandConfig.mr = marginConfig.marginRight;
marginShorthandConfig.mb = marginConfig.marginBottom;
marginShorthandConfig.ml = marginConfig.marginLeft;
marginShorthandConfig.marginX = {
  properties: ['marginTop', 'marginBottom']
};
marginShorthandConfig.mx = marginShorthandConfig.marginX;
marginShorthandConfig.marginY = {
  properties: ['marginLeft', 'marginRight']
};
marginShorthandConfig.my = marginShorthandConfig.marginY;
marginShorthandConfig.marginStart = marginConfig.marginInlineStart;
marginShorthandConfig.ms = marginConfig.marginInlineStart;
marginShorthandConfig.marginEnd = marginConfig.marginInlineEnd;
marginShorthandConfig.me = marginConfig.marginInlineEnd;
const margin = compose(system(marginConfig), system(marginShorthandConfig));

export { margin };
